// Spinner component
import { h } from '@lib/dom/createElement.js';

/**
 * Create a spinner/loading component
 * @param {Object} props
 * @param {string} props.size - 'sm' | 'md' | 'lg'
 * @param {string} props.color - CSS color value
 * @returns {HTMLElement}
 */
export default function Spinner({ size = 'md', color = 'var(--color-primary)' } = {}) {
  const sizes = { sm: '16px', md: '24px', lg: '40px' };
  const dim = sizes[size] || sizes.md;

  const spinner = h('div', {
    className: 'spinner',
    style: {
      width: dim,
      height: dim,
      border: `3px solid var(--color-border)`,
      borderTopColor: color,
      borderRadius: '50%',
      animation: 'spin 0.6s linear infinite',
    },
  });

  return spinner;
}
